import api from "../../api.service"
import { getPaginatedResponse } from "../utils"

const queryString = require("query-string")

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/group/endpoint-clients
 */
export function getOrgClients(orgId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/orgs/${orgId}/clients?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}

/**
 * For query parameters, see:
 * https://docs.api.missionx.ai/operation/operation-get-planitems
 */
export function getOrgClientsLite(orgId, queryParams = {}) {
    const qs = queryString.stringify(queryParams)
    return api
        .get(`/v2/orgs/${orgId}/clients/lite?${qs}`)
        .then((res) => getPaginatedResponse(res.data))
        .catch((err) => {
            throw api.getResponseError(err)
        })
}
